var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 9.37479C15.0001 5.1942 11.9593 1.72437 7.969 1.05483C8.42639 0.978093 8.89602 0.9375 9.37521 0.9375C14.035 0.9375 17.8125 4.71501 17.8125 9.37479C17.8125 14.0346 14.035 17.8121 9.37521 17.8121C8.89602 17.8121 8.42639 17.7715 7.969 17.6947C11.9593 17.0252 15.0001 13.5554 15.0001 9.37479Z",
    fill: "#CEE1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1761 23.1756C23.7074 22.6443 24 21.9381 24 21.1871C24 20.4361 23.7074 19.7298 23.1761 19.1985L19.8757 15.8981C19.5096 15.532 18.916 15.532 18.5499 15.8981C18.1839 16.2643 18.1838 16.8578 18.5499 17.2239L21.8503 20.5243C22.2157 20.8897 22.2157 21.4844 21.8503 21.8498C21.4838 22.2164 20.8914 22.2164 20.5248 21.8498L17.2244 18.5494C16.8583 18.1833 16.2647 18.1833 15.8987 18.5494C15.5326 18.9156 15.5325 19.5091 15.8987 19.8752L19.199 23.1756C20.2983 24.2749 22.0767 24.275 23.1761 23.1756Z",
    fill: "#522E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37524 18.7495C14.5445 18.7495 18.75 14.544 18.75 9.37476C18.75 4.20552 14.5445 0 9.37524 0C4.206 0 0.000476837 4.20552 0.000476837 9.37476C0.000476837 14.544 4.206 18.7495 9.37524 18.7495ZM9.37524 1.87495C13.5106 1.87495 16.875 5.23937 16.875 9.37476C16.875 13.5102 13.5106 16.8746 9.37524 16.8746C5.2398 16.8746 1.87543 13.5102 1.87543 9.37476C1.87543 5.23937 5.23984 1.87495 9.37524 1.87495Z",
    fill: "#522E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68765 10.3123C5.20542 10.3123 5.62513 9.89262 5.62513 9.37486C5.62513 7.30716 7.30733 5.62495 9.37503 5.62495C9.89279 5.62495 10.3125 5.20524 10.3125 4.68748C10.3125 4.16971 9.89279 3.75 9.37503 3.75C6.27349 3.75 3.75018 6.27331 3.75018 9.37486C3.75018 9.89262 4.16989 10.3123 4.68765 10.3123Z",
    fill: "#EE1451"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.52bc54ae0867fe5ada38a1a586a91541.svg";
export { ForwardRef as ReactComponent };